export const Logger = console;
